import React from "react";
import {
  Wrapper,
  AccountNumber,
  Bottom,
  Label,
  Bank,
  Country,
  Top,
  Circle,
} from "./style";
import { CardProps } from "../../../types";
import { getCountryNameFromCode } from "../BeneficiaryModal/utils";

const Card = ({
  bankName,
  accName,
  accNumber,
  beneficiary,
  currency,
  selectedRecipientId,
  setSelectedRecipient,
  disabled,
  width,
}: CardProps) => {
  const countryName = getCountryNameFromCode(beneficiary.countryCode || currency);

  return (
    <Wrapper
      width={width}
      $isSelected={selectedRecipientId === beneficiary.id}
      $disabled={disabled}
      onClick={() => setSelectedRecipient(beneficiary)}
    >
      <Top>
        <div>
          <Label>{accName}</Label>
          <AccountNumber>{accNumber}</AccountNumber>
        </div>

        <Circle
          $isSelected={selectedRecipientId === beneficiary.id}
          $disabled={disabled}
        />
      </Top>

      <Bottom>
        <Bank>{bankName}</Bank>
        <Country>{countryName}</Country>
      </Bottom>
    </Wrapper>
  );
};

export default Card;
